import React, { useState, useEffect } from "react";
import { Droppable } from "react-beautiful-dnd";
import {ListItemCustom} from "./ListItemCustom";
import { Typography, Button, IconButton, Menu, MenuItem, Box, TextField, List, ListItem, ListItemIcon } from "@mui/material";
import hashFill from '@iconify/icons-eva/hash-fill';
import { Icon } from '@iconify/react';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import { getMeasuresList, updateMeasure } from '../../config/services/measures';

const Column = ({ column, reportDetails, updateReportDetails, setPivotConfig, pivotConfig }) => {
  const [fieldListAnchor, setFieldListAnchor] = useState(null);
  const [searchMeasure, setSearchMeasure] = useState(null)
  const [measureList, setMeasureList] = useState([])

  const handleClose = () => {
    setFieldListAnchor(null);
  };


  const fetchMeasureList = () => {
    if (reportDetails && reportDetails.reportDetails && reportDetails.reportDetails.dataSetId && reportDetails.reportDetails.dataSetId._id) {
      let params = { dataSetId: reportDetails?.reportDetails?.dataSetId?._id, search: searchMeasure }
      getMeasuresList(params)
        .then((res) => {
          let measures = res?.result?.filter(obj => obj.dataSetType === 'MEASURE')
          setMeasureList(measures);
        });
    }
  }

  // useEffect(() => { fetchMeasureList() }, [fieldListAnchor, searchMeasure]);


  const handleSearchMeasure = (e) => {
    e.stopPropagation();
    let { value } = e.target
    setSearchMeasure(value)
    fetchMeasureList()
  }


  const setClassNameMeasureReport = (measure) => {
    let findInMeasures = reportDetails?.reportDetails?.measures.find(item => item.fieldId === measure._id)
    let findInDimensions = reportDetails?.reportDetails?.dimensions.find(item => item.fieldId === measure._id)

    if (findInMeasures || findInDimensions)
      return "visualize_list_text"

    return "";
  }


  const clickMeasureListHandler = (e, measure) => {
    e.stopPropagation();
    let measureIndex = -1
    let measureInLineFieldIndex = -1

    if (measure.dataSetType === "MEASURE") {
      measureIndex = reportDetails?.reportDetails?.measures?.findIndex(obj => obj.fieldId === measure?._id)
      measureInLineFieldIndex = column?.list?.findIndex(obj => obj.id === measure._id)

      if (measureInLineFieldIndex >= 0) {
        column.list.splice(measureInLineFieldIndex, 1)
      }
      else if (measureIndex < 0) {
        column.list.push({ text: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name, id: measure._id, type: 'measures' })
      }

      if (measureIndex >= 0) {
        reportDetails.reportDetails.measures = reportDetails?.reportDetails?.measures.filter(item => item?.fieldId !== measure?._id)
        reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => ele?.content?.key !== reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name)
      }
      else {
        reportDetails?.reportDetails?.measures.push({
          fieldName: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
          fieldId: measure?._id,
          displayName: measure?.displayName
        });

        reportDetails?.reportDetails?.orderBy.push({
          id: measure?._id,
          content: {
            key: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
            displayName: measure?.displayName,
            order: 'desc'
          }
        })
      }
    }

    updateReportDetails({ reportDetails: reportDetails.reportDetails });
  }


  const handleAddMeasureLine = (event) => {
    fetchMeasureList()
    setFieldListAnchor(event.currentTarget);
  };

  const renderBoxContent = (itemObject, index) => {
    if (column?.id === 'value' && itemObject?.text !== 'measures' && itemObject?.type !== 'measures') {
      return
    }

    if (itemObject?.visibleInFieldwell === false)
      return

    return <ListItemCustom index={index} itemObject={itemObject}
      key={itemObject.id} reportDetails={reportDetails}
      updateReportDetails={updateReportDetails} setPivotConfig={setPivotConfig}
      pivotConfig={pivotConfig} colId={column.id} />
  }

  return (
    <div className={column.id === 'value' ? 'pivotMeasureBox' : 'pivotDimensionBox'}>
      <Typography variant={"h5"} style={{ fontSize: "14px" }}>
        {column.label}
        {column.id === 'Lines' ? <IconButton color="primary" title='Add Fields' onClick={handleAddMeasureLine}> <AddOutlinedIcon /> </IconButton> : null}
      </Typography>

      <Droppable droppableId={column.id} >
        {(provided) => (
          <div ref={provided.innerRef} >
            <List>
              {column?.list?.map((itemObject, index) => (
                renderBoxContent(itemObject, index)
              ))}
              {provided.placeholder}
            </List>
          </div>
        )}
      </Droppable>


      <Menu
        id="simple-menu"
        anchorEl={fieldListAnchor}
        keepMounted
        open={Boolean(fieldListAnchor)}
        onClose={handleClose}
        className="pivotMenu"
      >
        <div>
          <Box width="100%" height="100%" mt={2}>
            <TextField className="cm_rprt_setting_content" type="search" size="small" label="Fields list" placeholder="Search fields.." onChange={e => handleSearchMeasure(e)} />
          </Box>
          <div className="field_list" >
            <List component="nav" aria-label="main mailbox folders" className="field_list">
              {measureList?.map((measure, i) => (
                <ListItem button className={setClassNameMeasureReport(measure)} onClick={(e) => clickMeasureListHandler(e, measure)}>
                  <ListItemIcon className="">
                    {measure.dataSetType === "MEASURE" ? <FunctionsOutlinedIcon className="cm_dimension_icon" /> : measure.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon" /> : measure.type === "time" ? <DateRangeIcon className="cm_measr_lbl" /> : <LabelOutlinedIcon className="cm_measr_lbl" />}
                  </ListItemIcon>
                  <Typography component="caption"> {measure?.displayName ?? measure?.name} </Typography>
                </ListItem>
              ))}
            </List>
          </div>
        </div>
      </Menu>
    </div>
  );
};

export default Column;
